"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelAdapter = void 0;
var ChannelAdapter = /** @class */ (function () {
    function ChannelAdapter() {
    }
    return ChannelAdapter;
}());
exports.ChannelAdapter = ChannelAdapter;
//# sourceMappingURL=channel-adapter.js.map